import { ArrowRight, CircleCheck } from 'lucide-react'

import { type Edge, EdgeKind, TERMINAL } from './tree'

/** One branch out of a question: what happens, and which question comes next. */
export function EdgeRow({ edge }: { edge: Edge }) {
  return (
    <li className="flex flex-wrap items-center gap-x-2 gap-y-1">
      {edge.kind === EdgeKind.ANSWER ? (
        <span className="border-ink-200 text-ink rounded-full border px-2 py-0.5 text-xs">{edge.label}</span>
      ) : (
        <span className="text-ink-400 text-xs italic">{edge.label}</span>
      )}
      <ArrowRight className="text-ink-300 size-3 shrink-0" />
      {edge.to === TERMINAL ? (
        <span className="text-brand-800 inline-flex items-center gap-1 font-mono text-[10px]">
          <CircleCheck className="size-3" />
          END
        </span>
      ) : (
        <span className="text-ink-600 font-mono text-[10px]">{edge.to}</span>
      )}
    </li>
  )
}
